export default function ErrorPage() {
  return (
    <>
      {/* <SEO title="Error Page" /> */}
      <div className="hight-screen">
        <h1 className="text-center">PAGE ERROR</h1>
      </div>
    </>
  )
}
